import type { DivergenceField } from "@/api/db/connection";
import type { ReviewConflict } from "@/api/db/people";

type Resolution = ReviewConflict["resolution"];

const resolutionLabel: Record<Resolution, string> = {
	review: "Pendentes de decisão humana",
	shared_phone: "Telefone compartilhado entre pessoas distintas",
	probable_typo: "Prováveis erros de digitação",
	check_digit: "Resolvidos por dígito verificador",
	plausibility: "Resolvidos por plausibilidade de data",
	both_kept: "Informações distintas mantidas",
	intra_source_dedup: "Duplicatas internas",
};

const conflictFieldLabel: Record<string, string> = {
	name: "Nome",
	cpf: "CPF",
	rg: "RG",
	birth_date: "Nascimento",
	phone: "Telefone",
	email: "Email",
	address: "Endereço",
	cep: "CEP",
	occupation: "Ocupação",
	record: "Registro",
	mother_name: "Nome da mãe",
	marital_status: "Estado civil",
	has_insurance: "Possui convênio",
	insurance: "Convênio",
	photo: "Foto",
};

const conflictDetailLabel: Record<NonNullable<ReviewConflict["detail"]>, string> = {
	absorbed_into_primary: "Linha absorvida pela primária do grupo",
	distinct_cep: "CEPs distintos, ambos mantidos",
	erp_implausible: "Nascimento do ERP implausível, mantido o do Monday",
	monday_implausible: "Nascimento do Monday implausível, mantido o do ERP",
	check_digit_valid: "Mantido o CPF com dígito verificador válido",
	shared_by_distinct_people: "Telefone compartilhado por pessoas distintas",
};

export const RevisaoLabels = {
	resolution: resolutionLabel,
	keep: "Manter atual",
	replace: "Trocar pela nova",
	field(code: string) {
		return conflictFieldLabel[code] ?? code;
	},
	divergenceValue(field: DivergenceField, side: "current" | "incoming", value: string | null) {
		if (field === "photo") {
			return side === "current" ? "Foto atual" : "Foto nova";
		}

		if (field === "has_insurance") {
			if (value === "true") {
				return "Sim";
			}

			if (value === "false") {
				return "Não";
			}

			return null;
		}

		return value;
	},
	detail(code: NonNullable<ReviewConflict["detail"]>) {
		return conflictDetailLabel[code];
	},
};
